/**
 * @description Tab navigation bar for the portal screens
 *
 * Key features:
 * - Horizontal tab strip
 * - Active state highlighting
 * - Disabled state for Phase 2 tabs
 * - Mobile-friendly touch targets
 */

import React from 'react';

const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  return (
    <nav className="flex border-b border-slate-700 bg-slate-800/50">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          onClick={() => !tab.disabled && onTabChange(tab.key)}
          disabled={tab.disabled}
          className={`
            flex-1 px-4 py-3 text-sm font-medium transition-colors min-h-touch
            ${activeTab === tab.key
              ? 'text-primary-400 border-b-2 border-primary-400'
              : tab.disabled
                ? 'text-slate-600 cursor-not-allowed'
                : 'text-slate-400 hover:text-white'
            }
          `}
        >
          {tab.label}
          {tab.disabled && <span className="ml-1 text-xs text-slate-600">(Soon)</span>}
        </button>
      ))}
    </nav>
  );
};

export default TabNavigation;
